import React from 'react';
import { Button } from './ui/button';
import { MessageCircle, Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ContactUsButton = ({ variant = 'outline', className = '' }) => {
  const { t } = useTranslation();

  const handleContactUs = () => {
    const subject = encodeURIComponent('Support Request - Bohol Trabaho');
    const body = encodeURIComponent(
      'Hello Bohol Trabaho Support Team,\n\n' +
      'I need assistance with:\n\n' +
      '[Please describe your issue or question here]\n\n' +
      'Thank you!'
    );
    
    window.location.href = `mailto:support@boholtrabaho.com?subject=${subject}&body=${body}`;
  };

  return (
    <Button 
      variant={variant}
      onClick={handleContactUs}
      className={`gap-2 ${className}`}
      title={t('common.contactSupport', 'Contact Support')}
    >
      <MessageCircle size={18} />
      <span className="hidden sm:inline">{t('common.contactUs', 'Contact Us')}</span>
      <span className="sm:hidden">Support</span>
    </Button>
  );
};

export default ContactUsButton;
